import { isNil, mergeWith } from 'lodash';

export function combineObject<T>(objectA: any, objectB: any): T {
  objectA = objectA || {};
  objectB = objectB || {};
  return mergeWith({}, objectA, objectB, (objValue: any, srcValue: any) => isNil(objValue) ? srcValue : isNil(srcValue) ? objValue : objValue) || {};
}
